import React, { useState, useEffect } from 'react'
import { postAPI } from '../../../app/api'
import Header from '../../Universal/Header'
import Footer from '../../Universal/Footer'
import galleryBanner from "../../../theme/assets/images/gallery-banner.svg"
import viewIcon from "../../../assets/img/view-icon.svg"
import Modal from '../../../GlobalComponent/Modal'

const { REACT_APP_BRANDURL } = process.env;

// Add CSS for skeleton loader animation
const skeletonStyles = `
  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
  }
`;

if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = skeletonStyles;
  document.head.appendChild(style);
}

const Infrastructure = () => {
  const [clickedImg, setClickedImg] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [HeroData, setHeroData] = useState(null);
  const [HeroLoading, setHeroLoading] = useState(true);
  const [infrastructureImages, setInfrastructureImages] = useState([]);
  const [imagesLoading, setImagesLoading] = useState(true);

  // Fallback hero data for 'infrastructure' route
  const fallbackHeroData = {
    title: 'Together in infrastructure',
    description: 'The BE College Ex-Students\' Club boasts a well-developed infrastructure designed to support cultural programs, meetings, seminars, and social gatherings. From its spacious ground floor hall to the modern lounge on the upper floors, the building reflects years of dedication, planning, and collective effort by our members. Each space has been thoughtfully created to foster interaction, learning, and community bonding.',
    image: galleryBanner,
    route: 'infrastructure'
  };

  // Fetch hero data for 'infrastructure' route
  useEffect(() => {
    fetchHeroData();
    fetchInfrastructureImages();
  }, []);

  const fetchHeroData = async () => {
    try {
      setHeroLoading(true);
      const response = await postAPI('hero-data/fetchData/infrastructure', {});

      if (response?.status === 1 && response?.data) {
        setHeroData(response.data);
      } else {
        setHeroData(fallbackHeroData);
      }
    } catch (error) {
      console.error('Error fetching hero data:', error);
      setHeroData(fallbackHeroData);
    } finally {
      setHeroLoading(false);
    }
  }

  // Fetch infrastructure images from API
  const fetchInfrastructureImages = async () => {
    try {
      setImagesLoading(true);
      const response = await postAPI('gallery/listInfrastructureFiles', {});

      if (response?.status === 1 && response?.data) {
        // Format image URLs with base URL
        const formattedImages = response.data.map(item => ({
          ...item,
          link: item.link?.startsWith('http') ? item.link : `${REACT_APP_BRANDURL}${item.link}`
        }));
        setInfrastructureImages(formattedImages);
      }
    } catch (error) {
      console.error('Error fetching infrastructure images:', error);
    } finally {
      setImagesLoading(false);
    }
  }

  const handleClick = (item, index) => {
    setCurrentIndex(index);
    setClickedImg(item.link);
  };

  const handelRotationRight = () => {
    const totalLength = infrastructureImages.length;
    if (totalLength === 0) return;
    if (currentIndex + 1 >= totalLength) {
      setCurrentIndex(0);
      const newUrl = infrastructureImages[0].link;
      setClickedImg(newUrl);
      return;
    }
    const newIndex = currentIndex + 1;
    const newUrl = infrastructureImages.filter((item) => {
      return infrastructureImages.indexOf(item) === newIndex;
    });
    const newItem = newUrl[0].link;
    setClickedImg(newItem);
    setCurrentIndex(newIndex);
  };

  const handelRotationLeft = () => {
    const totalLength = infrastructureImages.length;
    if (totalLength === 0) return;
    if (currentIndex === 0) {
      setCurrentIndex(totalLength - 1);
      const newUrl = infrastructureImages[totalLength - 1].link;
      setClickedImg(newUrl);
      return;
    }
    const newIndex = currentIndex - 1;
    const newUrl = infrastructureImages.filter((item) => {
      return infrastructureImages.indexOf(item) === newIndex;
    });
    const newItem = newUrl[0].link;
    setClickedImg(newItem);
    setCurrentIndex(newIndex);
  };

  return (
    <>
      <Header />
      <section className="hero-section">
        <div className="banner-image">
          {HeroLoading ? (
            <div style={{
              height: '500px',
              backgroundColor: '#e0e0e0',
              animation: 'pulse 1.5s infinite',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span style={{ color: '#999' }}>Loading...</span>
            </div>
          ) : (

            <img
              src={HeroData?.backgroundImage ? (HeroData.backgroundImage.startsWith('http') ? HeroData.backgroundImage : `${process.env.REACT_APP_APIURL || 'https://beapi.shikshaprime.com/'}${HeroData.backgroundImage.startsWith('/') ? HeroData.backgroundImage.slice(1) : HeroData.backgroundImage}`) : fallbackHeroData.image}
              className="img-fluid"
              style={{ width: '100%', height: '500px', objectFit: 'cover' }}
              alt="banner"
              onError={(e) => { e.target.src = fallbackHeroData.image; }}
            />


          )}
        </div>
        <div className="hero-content">
          {HeroLoading ? (
            <>
              <div className="skeleton-loader" style={{ height: '60px', backgroundColor: '#e0e0e0', marginBottom: '20px', animation: 'pulse 1.5s infinite', borderRadius: '4px' }} />
              <div className="skeleton-loader" style={{ height: '80px', backgroundColor: '#e0e0e0', animation: 'pulse 1.5s infinite', borderRadius: '4px' }} />
            </>
          ) : (
            <>
              <h1
                className="fw-bold display-5"
              >
                {HeroData?.title || fallbackHeroData.title}
              </h1>
              <p
                className="mt-lg-3 mt-1 mb-0"
              >
                The B E College Ex-Students' Club features well-developed infrastructure supporting cultural programs, meetings, seminars, and social gatherings. Its thoughtfully designed spaces reflect years of collective effort, fostering interaction, learning, and community bonding.
              </p>
            </>
          )}
        </div>
      </section>
      <div className='infrastructure'>
        <div className='container'>
          <div className='row justify-content-center'>
            {imagesLoading ? (
              // Loading skeleton for images
              [...Array(6)].map((_, index) => (
                <div key={index} className='col-lg-4 col-md-6 col-sm-10 col-12'>
                  <div className='gallery-item' style={{
                    height: '250px',
                    backgroundColor: '#e0e0e0',
                    animation: 'pulse 1.5s infinite',
                    borderRadius: '8px',
                    marginBottom: '20px'
                  }} />
                </div>
              ))
            ) : infrastructureImages.length > 0 ? (
              infrastructureImages.map((item, index) => (
                <div key={index} className='col-lg-4 col-md-6 col-sm-10 col-12'>
                  <div href='#' className='gallery-item'>
                    <img src={item.link} alt={item.title || 'Infrastructure'} />
                    <div className="overlay" onClick={() => handleClick(item, index)}>
                      <span className="plus-icon"><img src={viewIcon} /></span>
                      <div className="img-info">
                        {/* <small>{item.date}</small> */}
                        <h6 className="mb-0">{item.title}</h6>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className='col-12 text-center py-5'>
                <p className='text-muted'>No infrastructure images available</p>
              </div>
            )}
          </div>
        </div>
      </div>
      {clickedImg && (
        <Modal
          clickedImg={clickedImg}
          handelRotationRight={handelRotationRight}
          setClickedImg={setClickedImg}
          handelRotationLeft={handelRotationLeft}
        />
      )}
      <Footer />
    </>
  )
}

export default Infrastructure
